import React, {Component} from 'react';
import styles from "./shenhe.module.css";
import {FILE_URL} from "../../../util/constants";
import back from "../../../img/ic_back.png";


const Shenhe = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.onRequestClose}/>
            <div className={styles["modal-title"]}>活动审核</div>
        </div>

        <div className={styles.container}>
            <div className={styles['container-top']}>
                <div className={styles["list-type"]}>
                    {
                        props.activityTypeList.map((item, index) => {
                            return (
                                <div className={styles["list-item-type"]}>
                                    <div
                                        className={props.js_huodong_code == item.js_huodong_code ? styles["type-selected"] : styles["type-unselected"]}
                                        onClick={props.clickHuodongType.bind(null, item.js_huodong_code, index)}
                                    >
                                        {item.js_huodong_name}
                                    </div>
                                </div>
                            );
                        })
                    }
                    <div className={styles["list-item-type"]}>
                        <div
                            className={props.js_huodong_code == '0' ? styles["type-selected"] : styles["type-unselected"]}
                            onClick={props.clickHuodongType.bind(null, '0', 0)}
                        >
                            其它
                        </div>
                    </div>
                </div>
            </div>


            <div className={styles['container-bottom']}>
                <div className={styles["list-suyang"]}>
                    <div className={styles["suyang-item"]}>
                        <div
                            className={props.shenhe_status == 0 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                            onClick={props.clickShenheTab.bind(null, 0)}>
                            待审核
                        </div>
                    </div>

                    <div className={styles["suyang-item"]}>
                        <div
                            className={props.shenhe_status == 1 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                            onClick={props.clickShenheTab.bind(null, 1)}>
                            审核已通过
                        </div>
                    </div>

                    <div className={styles["suyang-item"]}>
                        <div
                            className={props.shenhe_status == 3 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                            onClick={props.clickShenheTab.bind(null, 3)}>
                            审核未通过
                        </div>
                    </div>

                </div>

                <div className={styles.list}>
                    {
                        props.tianyuanList.length > 0 ? (
                                <React.Fragment>
                                    {
                                        props.tianyuanList.map((item, index, array) => {
                                            return (
                                                <div className={styles['list-item']}>
                                                    <div className={styles['list-item-top']}
                                                         onClick={props.chakanDongtai.bind(null, item.tianyuanid)}>
                                                        <img
                                                            className={styles['list-item-touxiang']}
                                                            src={item.teacher_img}
                                                            onError={props.handleImageErrored.bind(this, index)}
                                                        />
                                                        <div className={styles['div-name']}>
                                                            <div className={styles['item-name']}>{item.teacher_name}</div>
                                                            <div className={styles['item-date']}>{item.time}</div>
                                                        </div>
                                                    </div>
                                                    <div className={styles['list-item-bottom']}>

                                                        <div className={styles["div-content"]}
                                                             onClick={props.chakanDongtai.bind(null, item.tianyuanid)}>
                                                            {item.content}
                                                        </div>

                                                        <div className={styles["container-photo"]}
                                                             onClick={props.chakanDongtai.bind(null, item.tianyuanid)}>
                                                            {item.img.map((item0, index0, array) => {
                                                                return (
                                                                    <img
                                                                        className={item.img.length > 1 ? styles.photo : styles.photo2}
                                                                        src={item0.img}
                                                                        onError={props.handleImageErrored2.bind(this, index, index0)}
                                                                    />
                                                                )
                                                            })
                                                            }
                                                        </div>


                                                        <div className={styles["container-bt"]}>
                                                            <div className={styles["bt-green"]} onClick={props.checkYes.bind(null,item.tianyuanid,item.status)}>审核通过</div>

                                                            <div className={styles["bt-gray"]} onClick={props.checkNo.bind(null,item.tianyuanid,item.status)}>审核不通过</div>

                                                        </div>

                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </React.Fragment>
                            )
                            : (<div className={styles['no-data']}>暂无数据</div>)
                    }

                </div>


            </div>

        </div>
    </div>
)

export default Shenhe;
